import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07f863d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "container"
};
const _hoisted_2 = {
  key: 0,
  class: "car"
};
const _hoisted_3 = {
  class: "car-image-size"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "btn-container"
};
const _hoisted_6 = {
  key: 1,
  class: "loading-container"
};
const _hoisted_7 = {
  key: 1,
  class: "errorPage"
};
const _hoisted_8 = {
  class: "errorDetail"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center",
    "font-size": "0.6rem",
    "padding": "0.2rem 0",
    "font-weight": "500"
  }
}, "还车信息填报", -1));
const _hoisted_11 = {
  style: {
    "margin": "16px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_van_field = _resolveComponent("van-field");
  const _component_ImageUpload = _resolveComponent("ImageUpload");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", null, [!$data.errorText ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.detail ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.detail.images ? (_openBlock(), _createBlock(_component_van_swipe, {
    key: 0,
    class: "my-swipe",
    autoplay: 3000
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images.split(','), (url, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: url,
          class: "car-image-size"
        }, null, 8, _hoisted_4)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showDetail, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "car-content",
      key: index
    }, _toDisplayString(item.title + item.value), 1);
  }), 128)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["btn", $options.btnStatusStyle()]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onUseCar && $options.onUseCar(...args))
  }, _toDisplayString($options.btnStatus()), 3)])])) : _createCommentVNode("", true), $data.showLoading ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_a_spin, {
    size: "large"
  })])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $data.ImageEmpty,
    class: "image"
  }, null, 8, _hoisted_9), _createElementVNode("text", null, _toDisplayString($data.errorText), 1)])])), _createVNode(_component_van_overlay, {
    show: $data.showModal,
    title: "还车信息"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "wrapper",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [_createVNode(_component_van_form, {
      onSubmit: $options.handleOk,
      style: {
        "background-color": "white",
        "border-radius": "0.4rem"
      }
    }, {
      default: _withCtx(() => [_hoisted_10, _createVNode(_component_van_cell_group, {
        inset: "",
        style: {
          "margin-top": "2px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.params.after_mileage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.params.after_mileage = $event),
          modelModifiers: {
            number: true
          },
          type: "number",
          name: "mile",
          label: "当前里程",
          placeholder: "请输入当前里程",
          rules: [{
            required: true,
            validator: $options.validator,
            message: '请输入当前里程'
          }]
        }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
          name: "uploader",
          label: "图片上传"
        }, {
          input: _withCtx(() => [_createVNode(_component_ImageUpload, {
            upLoadImages: $data.imageList,
            ref: "imageUpload"
          }, null, 8, ["upLoadImages"])]),
          _: 1
        }), _createVNode(_component_van_field, {
          modelValue: $data.params.memo,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.params.memo = $event),
          rows: "3",
          autosize: "",
          label: "备注",
          type: "textarea",
          placeholder: "请输入备注",
          class: "textarea"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
        round: "",
        type: "default",
        onClick: $options.onCancel,
        style: {
          "width": "45%"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 取消 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_van_button, {
        round: "",
        type: "primary",
        "native-type": "submit",
        style: {
          "width": "45%"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      })])]),
      _: 1
    }, 8, ["onSubmit"])])]),
    _: 1
  }, 8, ["show"])]);
}